<template lang="pug">
    div.enotourism
        navbar
        section.section.section-1.is-relative.is-fullview.is-parallax
            div.is-vmiddle
                div.container.has-text-white.has-text-centered
                    h1.is-size-2.is-uppercase.has-text-weight-light.animated.fadeInUp.slow(v-html="$t('page_05.section_1.title')")

        section.section.section-2.is-medium
            div.container.has-text-centered
                h2.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_05.section_2.subtitle') }}
                div.has-text-centered.separator
                    div.is-inline-block
                h1.is-size-32.is-uppercase {{ $t('page_05.section_2.title') }}
                p.is-size-26 {{ $t('page_05.section_2.text_1') }}
                p {{ $t('page_05.section_2.text_2') }}
                div.columns.is-centered.is-variable.is-8
                    div.column.is-4
                        p.has-text-justified {{ $t('page_05.section_2.text_3') }}
                    div.column.is-4
                        p.has-text-justified {{ $t('page_05.section_2.text_4') }}

        section.section
            div.has-text-right
                img.image-anchor(src="../assets/images/5_enoturismo/Img_Visite-nos.jpg")
        section.section
            div.container.has-padding-mobile
                table.programs
                    thead
                        tr
                            th.is-size-11.is-uppercase.has-letter-spacing {{ $t('page_05.section_2.table.col_1') }}
                            th.is-empty
                            th.is-size-11.is-uppercase.has-letter-spacing {{ $t('page_05.section_2.table.col_2') }}
                    tbody
                        tr.program(v-for="(p, idx) in $t('page_05.section_2.table.items')")
                            td
                                div.columns.is-vcentered.is-mobile
                                    div.column.is-2.has-text-centered.has-border-right.program-number
                                        h1 {{ idx + 1 }}
                                    div.column
                                        h2.is-size-11.is-uppercase.has-letter-spacing-200 {{ p.subtitle }}
                                        p.is-size-22 {{ p.title }}
                            td.is-empty
                            td
                                div.columns
                                    div.column
                                        h3.is-size-11.is-uppercase.has-letter-spacing-200 {{ p.note || "&nbsp;" }}
                                        p.is-size-22(v-if="p.price") € {{ p.price }}
                div.has-text-centered.programs-notes
                    p {{ $t('page_05.section_2.note_01') }}
                    p {{ $t('page_05.section_2.note_02') }}

        section.section.section-3.has-background-white-ter
            div.container
                div.columns.is-multiline.is-mobile.is-gapless.is-marginless
                    div.column.is-4(v-for="i in $t('page_05.section_3.images')")
                        img.is-block.is-fullw(:src="require('../assets/images/5_enoturismo/' + i)")

        section.section.section-4.has-background-white-ter
            div.container.has-padding-mobile
                div.has-text-centered
                    h2.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_05.section_3.title') }}
                div.columns.is-vcentered
                    div.column.is-hidden-mobile
                        img.is-arrow.is-pointer(src="../assets/images/slider/left.svg", @click="slider.prev()")
                    div.column.is-10.has-overflow-hidden
                        div.testimonials-slider
                            div.testimonial.has-text-centered(v-for="t in $t('page_05.section_3.testimonials')")
                                h1.is-size-32.is-uppercase {{ t.title  }}
                                p.is-size-19 {{ t.message }}
                                p {{ t.from }}
                    div.column.has-text-right.is-hidden-mobile
                        img.is-arrow.is-pointer(src="../assets/images/slider/right.svg", @click="slider.next()")

        section.section.section-5
            div.contacts-content
                div.container
                    div.has-text-centered
                        h2.is-size-7.is-uppercase.has-letter-spacing-200 {{ $t('page_05.section_4.subtitle') }}
                        h1.is-size-1.is-uppercase {{ $t('page_05.section_4.title') }}

                    div.columns.is-centered
                        div.column.has-text-centered-mobile
                            h2.is-size-11.is-uppercase.has-letter-spacing {{ $t('page_05.section_4.block_1.name') }}
                            p(v-html="$t('page_05.section_4.block_1.text')")
                        div.column.has-text-centered-mobile
                            h2.is-size-11.is-uppercase.has-letter-spacing {{ $t('page_05.section_4.block_2.name') }}
                            p
                                a.contacts-email.is-size-6.has-text-weight-semibold(:href="'mailto:' + $t('page_05.section_4.block_2.email')") {{ $t('page_05.section_4.block_2.email') }}
                            p(v-html="$t('page_05.section_4.block_2.text')")
                        div.column.has-text-centered-mobile
                            h2.is-size-11.is-uppercase.has-letter-spacing {{ $t('page_05.section_4.block_3.name') }}
                            p(v-html="$t('page_05.section_4.block_3.text')")
        the-footer
</template>

<script>
import Siema from 'siema'

// -- Components
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'

export default {
    name: 'enotourism',
    components: { Navbar, TheFooter },
    mounted () {
        this.init()
    },
    methods: {
        init () {
            this.slider = new Siema({
                selector: '.testimonials-slider',
                duration: 750,
                easing: 'ease-out',
                perPage: 1,
                startIndex: 0,
                loop: true,
                onInit () {
                    setInterval(this.next.bind(this), 5000)
                }
            })

            this.pullRight()
        },
        pullRight () {
            const element = document.getElementsByClassName('image-anchor')[0]
            const containerLeft = document.getElementsByClassName('container')[1].getBoundingClientRect().left
            const clientWidth = document.documentElement.clientWidth - containerLeft
            element.style.width = clientWidth + 'px'
        }
    }
}
</script>

<style lang="stylus" scoped>

$blue = #12385e

.section-1
    background-image url("../assets/images/5_enoturismo/Enoturismo_banner.jpg")
    background-size cover

    @media screen and (max-width: 768px)
        background-image url("../assets/images/5_enoturismo/Enoturismo_banners-mobile.jpg")

.is-arrow
    width 1rem

.has-overflow-hidden
    overflow hidden

.blocks
    & div
        margin-bottom: 2.5rem

.programs
    margin-top: 75px
    border-spacing 40px 0
    width 100%
    color #12385e

    .program-number
        font-size 55px
        margin-right 3rem

        @media screen and (min-width 1024px  )
            border-right 1px solid $blue

    th
        border-bottom 1px solid $blue
        padding-bottom 10px
        color $blue

    td
        border-bottom 1px solid $blue
        vertical-align middle
        padding 2.250rem 0

    + p
        margin-top 50px
        margin-bottom 125px

    .program
        h2 + p, h3 + p
            margin-top 0.250rem

    .is-empty
        width 3rem
        border none

    @media screen and (max-width: 768px)
        .program-number
            padding 0 25px
            margin-right 5px

    &-notes
        padding 70px 0 75px 0

.section-2
    @media screen and (max-width: 768px)
        padding 100px 25px

    p + p
        margin 30px 0

    .separator
        margin 15px

        div
            height 30px
            border-left 1px solid $blue
        + h1
            margin-bottom 39px

    .is-size-3
        font-size 1.875rem !important

.section-3
    padding-top 7.5rem

.section-4
    padding 13rem 0

    .testimonial
        margin-top 2rem
        > *
            margin-bottom 20px

.section-5
    margin-top 15vh

    @media screen and (max-width 768px)
        margin-top 10vh

    .contacts-content
        height calc(100vw / 2.13)

        background url("../assets/images/5_enoturismo/Enoturismo_footer.jpg")
        background-position center
        background-size cover
        background-repeat no-repeat

        @media screen and (max-width: 768px)
            background-image url("../assets/images/5_enoturismo/Enoturismo_2.jpg")

        h2 + h1
            line-height 1
            margin-top 4.375rem
            margin-bottom 4rem
        h2 + p
            margin-top 5px

        @media screen and (max-width: 768px)
            height auto
            padding-bottom 500px
</style>
